// Spam-detection automation removed. Manual moderation via reports only.
export const useEnhancedSpamDetection = () => ({
  analyzeContent: async (_content: string, _kind?: string) => ({
    allowed: true,
    message: '',
    score: 0,
  }),
});
